import React, { useMemo } from "react";
//#region types
import { CommonEnums, StyleEnums } from "models/enums";
import { CustomerRatingProps } from "models/propTypes/customerPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid, Typography, Rating } from "@mui/material";
import { useRatingService } from "serviceHooks";
//#endregion
import { CSSHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import ThumbsUp from "images/thumb-up.png";
import ThumbsDown from "images/thumb-down.png";

const CustomerRating: React.FC<CustomerRatingProps> = (props) => {
  const ratingService = useRatingService();
  const { value } = props;
  const ratingInfo = useMemo(() => ratingService.getRatingInfo(CommonEnums.OrganizationTypes.Customer, value), [value]);

  const hasRating = value !== undefined && value !== null;

  return (
    <Grid
      container
      item
      direction="column"
      className={clsx(cssExports.ratingBubbleContainer, CSSHelper.getClassByDisplayType(ratingInfo.displayType))}
    >
      <Grid item container className={cssExports.ratingBubble}>
        <Grid container spacing={2} alignContent="center" justifyContent="center">
          {hasRating && (
            <Grid item container justifyContent="center" className={cssExports.customerRatingTitle}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.CreditRating)}
            </Grid>
          )}
          <Grid item container justifyContent="center">
            <Rating
              name="read-only"
              value={ratingInfo.ratingValue}
              precision={0.5}
              readOnly
              classes={{
                root: cssExports.ratingRoot,
                iconEmpty: cssExports.iconEmpty,
                iconFilled: cssExports.iconFilled,
              }}
            />
          </Grid>
          <Grid item container md={6} xs={8} justifyContent="center" className={cssExports.customerRatingText}>
            {hasRating ? (
              <>
                <Grid item container justifyContent="center" className={cssExports.ratingValue}>
                  <Typography align="center">{ratingInfo.ratingText}</Typography>
                </Grid>
                <Grid item container justifyContent="center">
                  <Typography align="center">
                    {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.OutOf, "", { total: "100" })}
                  </Typography>
                </Grid>
              </>
            ) : (
              <Typography align="center">{ratingInfo.ratingText}</Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid container item justifyContent="center" className={cssExports.ratingBubbleOriginText}>
        <Grid container item md={6} xs={8} justifyContent="center">
          <Typography align="center">{ratingInfo.displayText}</Typography>
        </Grid>
      </Grid>
      {value !== undefined && value !== null && (
        <Grid container className={cssExports.ratingBubbleThumbsUp}>
          <img src={ratingInfo.displayType === StyleEnums.DisplayType.Success ? ThumbsUp : ThumbsDown} />
        </Grid>
      )}
    </Grid>
  );
};

export default CustomerRating;
